{
    "longSHA": "66cdf45da42e79219f6f31c378e418bbddb21834",
    "shortSHA": "66cdf45",
    "branch": "development",
    "authorName": "Damjan Tonkli",
    "commitTime": "Fri Jan 16 12:17:28 2026 +0100",
    "commitMsg": "fix(invoice): max invoice item quantity and quantity2 lengths\n\nRefs: #41852",
    "totalCommitCount": "1"
}